/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FolderZipIcon from "@mui/icons-material/FolderZip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import DescargarArchivo from "../DescargaArchivos";
import { descargaZip } from "store/download/dowloadActions";

import backgroundImage from "assets/images/fondoesf.jpeg";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Header({ children, infomenor, esSolicitud }) {
  const navigate = useNavigate();
  const { progress, loading } = useSelector((state) => state.download);

  const dispatch = useDispatch();
  const DownloadZip = async (idSolicitud) => {
    if (!loading) {
      dispatch(descargaZip(idSolicitud));
    } else {
      toast.error("Solo es posible descargar un archivo a la vez, por favor a espera!!!");
    }
  };

  var name = "Roman Jimenez Maldonado";
  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="10rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0),
              rgba(gradients.info.state, 0.6)
            )}, url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Grid
        container
        spacing={3}
        alignItems="center"
        sx={{
          clear: "both",
          position: "absolute",
          top: 0,
        }}
      >
        <Grid item ml={1}>
          <MDBox>
            <Button
              variant="contained"
              startIcon={<Icon>arrow_back_ios_new</Icon>}
              color="primary"
              size="small"
              style={{ textTransform: "inherit" }}
              onClick={() => {
                if (esSolicitud) {
                  navigate("/solicitud");
                } else {
                  navigate("/expedientes");
                }
              }}
            >
              Regresar
            </Button>
          </MDBox>
        </Grid>
        <Grid item ml={1}>
          <MDAvatar alt="profile-image" size="md" shadow="sm" bgColor="info">
            {`${infomenor.nombre?.split(" ")[0][0]}${infomenor.nombre?.split(" ")[1][0]}`}
          </MDAvatar>
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox>
            <Box sx={{ maxHeight: "1.5rem" }}>
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="primary"
                fontWeight="medium"
                paddingRight={1}
              >
                Menor:
              </MDTypography>
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {infomenor.nombre}
              </MDTypography>
            </Box>
            <Box sx={{ maxHeight: "1.5rem" }}>
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="primary"
                fontWeight="medium"
                paddingRight={1}
              >
                Fecha Nacimiento:
              </MDTypography>
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {infomenor.fecha}
              </MDTypography>
            </Box>
            <Box>
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="primary"
                fontWeight="medium"
                paddingRight={1}
              >
                Fecha Aplicación:
              </MDTypography>
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                {infomenor.fechaAplicacion}
              </MDTypography>
            </Box>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }} textAlign={"center"}>
          <MDBox>
            <MDTypography
              component="a"
              href="#"
              variant="caption"
              color="primary"
              fontWeight="medium"
              paddingRight={1}
            >
              {infomenor.title}
            </MDTypography>
            <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
              N° {infomenor.idSolicitud}
            </MDTypography>
          </MDBox>
          <MDTypography variant="text" color="white" fontSize="12px">
            {loading ? (
              <DescargarArchivo progress={progress} />
            ) : (
              <MDButton
                variant="gradient"
                color="dark"
                textCapitalize="none"
                onClick={() => {
                  DownloadZip(infomenor.id);
                }}
              >
                <FolderZipIcon />
                &nbsp;Descargar Zip
              </MDButton>
            )}
          </MDTypography>
        </Grid>
      </Grid>
      <Card
        sx={{
          position: "relative",
          mt: "-5rem",
          mx: "1rem",
          py: "1rem",
          px: "1rem",
        }}
      >
        {children}
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
